<script>
  import cloneDeep from 'lodash.clonedeep'

  import FormMemberBase from './extends/FormMemberBase'

  export default {
    name: 'FormMeta',

    extends: FormMemberBase,

    props: {
      config: {
        type: Object,
        required: true,
      },
      showRemove: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['click', 'remove'],

    data() {
      return {
        model: cloneDeep(this.value),
      }
    },

    created() {
      if (this.model === undefined) {
        this.model = cloneDeep(this.config.defaultValue)
      }
    },

    methods: {
      emitRemove() {
        this.$emit('remove')
      },
    },
  }
</script>

<template>
  <component
    :is="getFormItem(config.formItem)"
    v-bind="config.formItem.props"
    :required="config.required"
    :validation-message="validationMessage"
    :show-remove="showRemove"
    class="form-meta"
    @remove="emitRemove"
  >
    <component
      :is="getInput(config.component)"
      v-if="config.type === 'number'"
      v-model.number="model"
      v-bind="config.component.props"
    />

    <component
      :is="getInput(config.component)"
      v-else-if="config.type === 'string'"
      v-model.trim="model"
      v-bind="config.component.props"
    />

    <component
      :is="getInput(config.component)"
      v-else
      v-model="model"
      v-bind="config.component.props"
    />
  </component>
</template>
